export enum ObservationMethodEnum {
  Observation = 1,
  InformalObservation = 9,
  Conference = 10
}
